import * as types from '../actions/actionTypes';
import initialState from "./initialState";

export function dayTypeCalendarReducer(
    state = initialState.dayTypeCalendar, action
) {
    switch (action.type) {
        case types.FETCH_DAY_TYPE_CALENDAR_SUCCESS:
            return action.dayTypeCalendar;
        default:
            return state;
    }
}

export function dayTypeSecurityReducer(
    state = initialState.dayTypeSecurity, action
) {
    switch (action.type) {
        case types.FETCH_DAY_TYPE_SECURITY_SUCCESS:
            return action.dayTypeSecurity;
        default:
            return state;
    }
}

export function resourceDayTypeReducer(
    state = initialState.resourceDayType, action
) {
    switch (action.type) {
        case types.ADD_RESOURCE_DAY_TYPE_SUCCESS:
            return action.resourceDayType;
        case types.EDIT_RESOURCE_DAY_TYPE_SUCCESS:
            return action.resourceDayType;
        case types.FETCH_RESOURCE_DAY_TYPE_BY_DATE_SUCCESS:
            return action.resourceDayType;
        case types.FETCH_RESOURCE_DAY_TYPE_BY_ID_SUCCESS:
            return action.resourceDayType;
        default:
            return state;
    }
}

export function dayTypeRequestsByYearReducer(
    state = initialState.dayTypeRequestsByYear, action
) {
    switch (action.type) {
        case types.FETCH_DAY_TYPE_REQUESTS_BY_YEAR:
            return action.dayTypeRequests;
        default:
            return state;
    }
}

export function dayTypesAllReducer(
    state = initialState.dayTypesAll, action
) {
    switch (action.type) {
        case types.FETCH_DAY_TYPES_ALL_SUCCESS:
            return action.dayTypesAll;
        default:
            return state;
    }
}

export function dayTypesAllWithoutForceTourReducer(
    state = initialState.dayTypesAllWithoutForceTour, action
) {
    switch (action.type) {
        case types.FETCH_DAY_TYPES_ALL_WITHOUT_FORCE_TOUR_SUCCESS:
            return action.dayTypesAllWithoutForceTour;
        default:
            return state;
    }
}

export function dayTypeRequestByIdReducer(
    state = initialState.dayTypeRequestById, action
) {
    switch (action.type) {
        case types.FETCH_DAY_TYPE_REQUEST_BY_ID:
            return action.dayTypeRequest;
        default:
            return state;
    }
}

export function dayTypeReducer(
    state = initialState.dayType, action
) {
    switch (action.type) {
        case types.ADD_DAY_TYPE_SUCCESS:
            return action.dayType;
        case types.EDIT_DAY_TYPE_SUCCESS:
            return action.dayType;
        case types.REMOVE_DAY_TYPE_SUCCESS:
            return action.dayType;
        default:
            return state;
    }
}

export function dayTypesByDayRuleReducer(
    state = initialState.dayTypesByDayRule, action
) {
    switch (action.type) {
        case types.FETCH_DAY_TYPES_BY_DAY_RULE:
            return action.dayTypes;
        default:
            return state;
    }
}

export function dayTypesAllowingTourSchedulingReducer(
    state = initialState.dayTypesAllowingTourScheduling, action
) {
    switch (action.type) {
        case types.FETCH_DAY_TYPES_ALLOWING_TOUR_SCHEDULING:
            return action.dayTypes;
        default:
            return state;
    }
}

export function dayTypeCalendarScheduleParametersReducer(
    state = initialState.dayTypeCalendarScheduleParameters, action
) {
    switch (action.type) {
        case types.EDIT_DAY_TYPE_CALENDAR_SCHEDULE_PARAMETERS_SUCCESS:
            return action.parameters;
        default:
            return state;
    }
}

export function ifHasHolidayScheduleReducer(
    state = initialState.ifHasHolidaySchedule, action
) {
    switch (action.type) {
        case types.FETCH_IF_HAS_HOLIDAY_SCHEDULE_SUCCESS:
            return action.ifHasHolidaySchedule;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/dayTypeReducer.js